import React from 'react';
import ReactDOM from 'react-dom/client';
import { TonConnectUIProvider } from '@tonconnect/ui-react';
import Donation from './components/Donation';
import SchoolList from './components/SchoolList';
import Connect from './components/Connect';
import Admin from './components/Admin';
import MyDonations from './components/MyDonations';
import { I18nProvider } from './i18n';
import './index.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

if (window.Telegram?.WebApp) {
    window.Telegram.WebApp.ready();
    try { window.Telegram.WebApp.expand(); } catch {}
}

const router = createBrowserRouter([
    { path: '/', element: <SchoolList /> },
    { path: '/admin', element: <Admin /> },
    { path: '/me', element: <MyDonations /> },
    { path: '/connect', element: <Connect /> },
    { path: '/donate/:schoolId', element: <Donation /> },
]);

ReactDOM.createRoot(document.getElementById('root')).render(
    <I18nProvider>
        <TonConnectUIProvider manifestUrl={`${window.location.origin}/tonconnect-manifest.json`}>
            <RouterProvider router={router} />
        </TonConnectUIProvider>
    </I18nProvider>
);
